export const MAJOR_MEDICAL_CONDITION = 'MAJOR_MEDICAL_CONDITION';
export const TOBACCO_USE = 'TOBACCO_USE';

export const addCheckBoxListFromInsuranceFormData = insuranceFormData => {
  const checkFormList = [];
  if (insuranceFormData.majorMedicalCondition) {
    checkFormList.push(MAJOR_MEDICAL_CONDITION);
  }
  if (insuranceFormData.tobaccoUse) {
    checkFormList.push(TOBACCO_USE);
  }
  return checkFormList;
};
